var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.43526 0C5.8927 0 6.26353 0.356629 6.26353 0.79655V2.40335C6.99823 2.38964 7.82175 2.38964 8.74834 2.38964H13.1658C14.0923 2.38964 14.9159 2.38964 15.6506 2.40335V0.79655C15.6506 0.356629 16.0214 0 16.4789 0C16.9363 0 17.3072 0.356629 17.3072 0.79655V2.47382C18.8967 2.59623 19.9403 2.89665 20.7068 3.63393C21.4735 4.37121 21.7859 5.37475 21.9132 6.90341L22.0009 7.69996H1.01799H0.000976562V6.90341C0.128257 5.37475 0.440644 4.37121 1.20729 3.63393C1.97394 2.89665 3.01745 2.59623 4.60698 2.47382V0.79655C4.60698 0.356629 4.97781 0 5.43526 0Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 14.0001V12.0001C22 11.161 21.9965 9.66526 21.9823 9H0.0110106C-0.00319018 9.66526 0.000406649 11.161 0.000406649 12.0001V14.0001C0.000406649 17.7712 0.000406628 19.6568 1.28911 20.8284C2.57782 22 4.65196 22 8.80026 22H13.2002C17.3485 22 19.4226 22 20.7114 20.8284C22 19.6568 22 17.7712 22 14.0001Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderVector);
export default __webpack_public_path__ + "static/media/calenderVector.f065259ba4b9c70c5647413c3b4f4526.svg";
export { ForwardRef as ReactComponent };